import {Component, ElementRef, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../../app.component';
import { ModalTypes } from '../../enums/modal-types';
import {ModalTemplates} from "../../enums/modal-templates";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal.component.less']
})
export class ModalComponent implements OnInit {
  public ModalType = ModalTypes;
  public ModalTemplate = ModalTemplates;
  modal_info?: any;
  global_texts?: any;

  constructor(
    public app: AppComponent,
    private el: ElementRef
  ) { }

  ngOnInit() {
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;

      // Get the modal info
      this.app.dialogService.getModalInfo().subscribe(info => {
        console.log("info ==> ", info);
        this.modal_info = info;

        this.modal_info?.data?.forEach((data: any) => {
          if (data.small_texts) data.small_texts = Object.values(data.small_texts);
        });
      });
    });
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (this.isModalOpen()) {
      event.preventDefault();
      this.triggerPrimaryButtonAction();
    }
  }

  isModalOpen(): boolean {
    // Logic to determine if the modal is open
    console.log('Logic to determine if the modal is open : ', this.el.nativeElement.querySelector('.modal') !== null)
    return this.el.nativeElement.querySelector('.modal') !== null;
  }

  triggerPrimaryButtonAction() {
    // Logic to trigger the primary button action of the modal
    const primaryButton = this.el.nativeElement.querySelector('.modal-footer .btn-solid-green');
    if (primaryButton) {
      primaryButton.click();
    }
  }

  styleModal(type: ModalTypes): Object {
    if (type == ModalTypes.Confirm) {
      return { width: '500px' }
    }
    if (type == ModalTypes.Alert) {
      return { width: '400px' }
    }
    return {}
  }

  styleModalContent(type: ModalTypes): Object {
    if (type == ModalTypes.Alert) {
      return { height: 'auto' }
    }
    return {}
  }
}
